import { getTimesheetDateLabel } from './formatters';
import type { WeekDay } from '../types';

const DAY_ORDER_TO_WEEKDAY: Record<number, WeekDay> = {
  1: 'monday',
  2: 'tuesday',
  3: 'wednesday',
  4: 'thursday',
  5: 'friday',
};

/** Calendar column keys (Mon–Fri) that are real workdays for this timesheet (not holiday / N/A). */
export function getTimesheetWorkdayWeekDays(weekStart: string, weekDates: string[]): WeekDay[] {
  if (!weekStart || !weekDates?.length) return [];
  const result: WeekDay[] = [];
  for (let dayOrder = 1; dayOrder <= 5; dayOrder++) {
    const label = getTimesheetDateLabel(weekStart, dayOrder);
    if (!label) continue;
    const headerDateArr = label.split(',')[1]?.trim().split('/') ?? [];
    if (headerDateArr.length < 3) continue;
    const headerDateFormatted = `${headerDateArr[2]}-${Number(headerDateArr[0])}-${Number(
      headerDateArr[1]
    )}`;
    if (weekDates.some((d) => d === headerDateFormatted)) {
      const key = DAY_ORDER_TO_WEEKDAY[dayOrder];
      if (key) result.push(key);
    }
  }
  return result;
}
